(() => {
  const MOBILE_BREAKPOINT = 749;
  const COPY_FEEDBACK_MS = 2000;

  const init = (root) => {
    const url = root.dataset.shareUrl || window.location.href;
    const title = root.dataset.shareTitle || document.title;
    const useNative = root.dataset.useNative === 'true';
    const translations = {
      native: root.dataset.labelNative || 'Share',
      copied: root.dataset.labelCopied || 'Copied!'
    };
    const list = root.querySelector('.blog-share__list');
    const announce = root.querySelector('[data-blog-share-announce]');
    const copyBtn = root.querySelector('[data-blog-share-copy]');

    if (useNative && list && 'share' in navigator && window.innerWidth <= MOBILE_BREAKPOINT) {
      const nativeBtn = document.createElement('li');
      nativeBtn.className = 'blog-share__item';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'blog-share__button blog-share__button--native';
      button.innerHTML =
        "<svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><circle cx='18' cy='5' r='3'></circle><circle cx='6' cy='12' r='3'></circle><circle cx='18' cy='19' r='3'></circle><path d='m8.59 13.51 6.83 3.98'></path><path d='m15.41 6.51-6.82 3.98'></path></svg>" +
        '<span>' +
        translations.native +
        '</span>';
      button.addEventListener('click', async () => {
        try {
          await navigator.share({ title, url });
        } catch (err) {
          if (err && err.name !== 'AbortError') {
            console.warn('Web Share failed', err);
          }
        }
      });
      nativeBtn.appendChild(button);
      list.insertBefore(nativeBtn, list.firstChild);
    }

    if (copyBtn) {
      const originalLabel = copyBtn.querySelector('[data-blog-share-copy-label]');
      const originalText = originalLabel ? originalLabel.textContent : '';
      copyBtn.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(url);
          copyBtn.classList.add('blog-share__button--copied');
          if (originalLabel) originalLabel.textContent = translations.copied;
          if (announce) announce.textContent = translations.copied;
          setTimeout(() => {
            copyBtn.classList.remove('blog-share__button--copied');
            if (originalLabel) originalLabel.textContent = originalText;
            if (announce) announce.textContent = '';
          }, COPY_FEEDBACK_MS);
        } catch (err) {
          console.warn('Clipboard copy failed', err);
        }
      });
    }
  };

  const start = () => {
    document.querySelectorAll('[data-blog-share]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
